// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1apLo","actionsCol":"EnrolledClinics_actionsCol__2-s0a"};